import { UsageFeatureProps } from '@micro-frontend-react/employee-experience/lib/UsageTelemetry';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useDynamicReducer } from '@micro-frontend-react/employee-experience/lib/useDynamicReducer';
import { useContext, useEffect } from 'react';
import { Reducer } from 'redux';
import { IEvlAppState } from '../../App.types';
import { IUserProfile } from '../../models/IUserProfile';
import { requestUserProfile } from '../actions/userProfileActions';
import { userProfileInitialState, userProfileReducer } from '../reducers/userProfileReducer';
import { userProfileSagas } from '../sagas/userProfileSagas';

export function useUserProfile(
  feature: UsageFeatureProps
): [IUserProfile, boolean, boolean, string | null] {
  useDynamicReducer(
    'userProfile_reducer',
    userProfileReducer as Reducer,
    [userProfileSagas],
    false
  );

  const { dispatch, useSelector } = useContext(
    Context as React.Context<IEmployeeExperienceContext>
  );

  const { userProfile, userProfileErrorMessage, userProfileHasError, isUserProfileLoading } =
    useSelector(
      (state: IEvlAppState) => state?.dynamic?.['userProfile_reducer'] ?? userProfileInitialState
    );

  useEffect(() => {
    dispatch(requestUserProfile(feature));
  }, [dispatch]);

  return [userProfile, isUserProfileLoading, userProfileHasError, userProfileErrorMessage];
}
